<script setup lang="tsx">
interface Props {
  sufix?: { IconClass?: string } | { text?: string }
  prefix?: { IconClass?: string } | { text?: string }
}

defineProps<Props>()
</script>
<template>
  <PvInputGroup>
    <PvInputGroupAddon
      v-if="prefix && Object.keys(prefix).every((k) => prefix && k && !isNil(prefix[k as keyof typeof prefix]))"
    >
      <span
        v-if="'IconClass' in prefix && prefix.IconClass"
        class="text-lg md:text-2xl leading-none"
        :class="prefix?.IconClass"
      />
      <span
        v-if="'text' in prefix && prefix.text"
        class="font-bold text-sm leading-none md:text-base"
      >
        {{ prefix.text }}
      </span>
    </PvInputGroupAddon>
    <slot />
    <PvInputGroupAddon
      v-if="sufix && Object.keys(sufix).every((k) => sufix && k && !isNil(sufix[k as keyof typeof sufix]))"
    >
      <span
        v-if="'IconClass' in sufix && sufix.IconClass"
        class="text-lg md:text-2xl leading-none"
        :class="sufix?.IconClass"
      />
      <span
        v-if="'text' in sufix && sufix.text"
        class="font-bold text-sm leading-none md:text-base"
      >
        {{ sufix.text }}
      </span>
    </PvInputGroupAddon>
  </PvInputGroup>
</template>
